<script lang="ts">
	import GlobalMedia from '$lib/components/media/GlobalMedia.svelte';
	import { page } from '$app/stores';
	import Media from '$lib/components/media/Media.svelte';
	import Text from '$lib/components/Text.svelte';
	import { pageList } from '$lib/stores/navStore';

	let showLangOptions: boolean = false;
	let urlParts: any = $page.url.pathname.split('/');
	let currentSlug = urlParts.join('/');
	let currentSlugList = {};
	let container: HTMLDivElement;

	function onWindowClick(e) {
		if (!container.contains(e?.target)) {
			showLangOptions = false;
		}
	}

	$: {
		urlParts = $page.url.pathname.split('/');
		urlParts.splice(0, 2);

		currentSlug = urlParts.join('/');

		if (currentSlug === '') {
			currentSlug = 'home';
		}

		currentSlugList = {};

		for (const page of $pageList) {
			if (page[$page.params?.lang] === currentSlug) {
				currentSlugList = page;
			}
		}
	}
</script>

<svelte:window on:click={onWindowClick} />
<div class="lang-selector-wrapper">
	<div class="lang-label">
		<Text key="ecom_language" />
	</div>
	<div
		bind:this={container}
		class="lang-selector"
		on:click={() => {
			showLangOptions = !showLangOptions;
		}}
	>
		<div class="current-lang">
			{$page.params?.lang?.toUpperCase()}
		</div>
		<div class="arrow">
			<GlobalMedia key="icon-caret-right" />
		</div>
		<div class="switcher-dropdown" class:open={showLangOptions}>
			{#each $page.data.languages as lang}
				<a
					class="switcher-option"
					href={'/' +
						lang.code +
						(currentSlugList[lang.code] === 'home'
							? ''
							: `/${currentSlugList[lang.code] ?? currentSlug}`) +
						'' +
						$page.url.search}
				>
					{lang.name}
				</a>
			{/each}
		</div>
	</div>
</div>

<style lang="scss">
	.lang-selector-wrapper {
		display: flex;
		align-items: center;
		gap: v(content-padding-xs);
	}

	.lang-label {
		@include font(text-xs);
		text-transform: none;
		margin-top: 0.25rem;
		letter-spacing: 0.1px;
	}

	.lang-selector {
		position: relative;
		background: color(grey_08);
		padding: 4px 8px;
		@include font(info-sm);
		display: flex;
		align-items: center;
		gap: 3px;
		border-radius: 4px;
		cursor: pointer;
		transition: all 0.3s ease;

		&:hover {
			background: color(grey_06);
		}

		.current-lang {
			display: flex;
			align-items: center;
			cursor: pointer;
		}

		.flag {
			width: 24px;
			height: 24px;
			color: white;
			margin-inline-end: 8px;
		}

		.arrow {
			width: 8px;
			height: 8px;
			display: flex;
			align-items: center;
		}

		.switcher-dropdown {
			position: absolute;
			top: 48px;
			inset-inline-start: 50%;
			transform: translate(calc(v(dir) * -50%), -32px);
			max-width: 80vw;
			z-index: 5;

			padding: 8px;
			background: white;
			border-radius: v(border-radius);
			box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);

			display: flex;
			flex-direction: column;
			opacity: 0;
			@include transition(all);
			pointer-events: none;

			&.open {
				opacity: 1;
				transform: translate(calc(v(dir) * -50%), 0);
				pointer-events: auto;
			}
		}

		.switcher-option {
			display: flex;
			align-items: center;
			cursor: pointer;
			padding: 12px 24px;
			border-radius: v(border-radius);
			@include transition(all);
			text-decoration: none;

			color: color(text);

			&:hover {
				background: #fff;
			}
		}
	}
</style>
